import ReactDOM from 'react-dom/client'
import App from './App.tsx'
import './index.css'
import '@channelplay/table-actions/styles.css'

// Global error handlers to catch any uncaught errors
window.onerror = (message, source, lineno, colno, error) => {
  console.error('🔴 Global Error:', { message, source, lineno, colno, error });
  return false;
};

window.onunhandledrejection = (event) => {
  console.error('🔴 Unhandled Promise Rejection:', event.reason);
};

ReactDOM.createRoot(document.getElementById('root')!).render(
  <App />
)
